import moment, { MomentInput } from 'moment';

export const formatDate = (value?: MomentInput): string => {
  return value ? moment(value).format('DD.MM.YYYY') : '';
};

export const formatDateTime = (value?: MomentInput): string => {
  return value ? moment(value).format('DD.MM.YYYY HH:mm') : '';
};
